import { ConnectedSolveResult } from 'components/common-form/sidePanel/status/stream/SolveResult';
import { connectStream } from 'components/common-form/sidePanel/status/stream/Stream.connect';
import { StreamingTradeDoneProps } from 'components/common-form/sidePanel/status/stream/tradeDone/StreamingTradeDone.connect';
import { ConnectedUnderlying } from 'components/common-form/sidePanel/status/stream/Underlying';
import { ConnectedTradeWayLiteral, PriceNext, QuoteStatus } from 'components/shared/PriceNext';

import { SolveModeLabel } from '../../SolveMode';

function StreamingTradeDone({ workspaceType, solvingMode, tabId, isForBooking }: StreamingTradeDoneProps) {
  return (
    <PriceNext
      className={'sg-price bg-info bg-opacity-10 text-info'}
      tradeWay={<ConnectedTradeWayLiteral tabId={tabId} workspaceType={workspaceType} />}
      solveMode={
        <SolveModeLabel workspaceType={workspaceType} solvingMode={solvingMode} isMultipleSolvingMode={false} />
      }
      fxSpot={<ConnectedUnderlying formId={tabId} />}
      solveResult={<ConnectedSolveResult formId={tabId} />}
      quoteStatus={
        <QuoteStatus
          className="bg-info"
          icon="check_circle"
          description={isForBooking ? 'sidePanel.quoteStatus.tradeBooked' : 'sidePanel.quoteStatus.tradeTraded'}
        />
      }
    />
  );
}

export const StreamingTradeDoneComponent = connectStream(StreamingTradeDone);
